import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useIntl } from "react-intl";

import { HallsStore } from "@/stores";

import HallCreateForm from "./hall-create-short-form";

type TProps = {
  hallsStore: HallsStore;
};

function HallCreateShortModal({ hallsStore }: TProps) {
  const { hallCreateStore } = hallsStore;
  const intl = useIntl();

  return (
    <Modal
      title={intl.formatMessage({ defaultMessage: "New shop" })}
      open={hallCreateStore.modalShort.isOpen}
      onCancel={hallCreateStore.modalShort.close}
      width={720}
      footer={null}
      destroyOnClose={true}
    >
      <HallCreateForm hallsStore={hallsStore} />
    </Modal>
  );
}

export default observer(HallCreateShortModal);
